import css from './H3title.module.scss';
import classNames from 'classnames';

export default function H3title({children, cn, isWhite}) {
  return (
    <h3 className={classNames(css.h3, cn, {[css.white]: isWhite})}>{children}</h3>
  );
}